import request from "../../untils/request.js"


export const financialCategoryTransfer = (data) => {
    return request.post("/outpatient/docclinic/transfer", data )
}

export const docClinicFundList = (data) => {
    return request.get("/outpatient/docclinic/fundList", data )
}